import React from 'react';
import { History } from 'lucide-react';

export const DraftBar = ({ draft }) => {
  if (!draft?.offer) return null;
  const at = new Date(draft.offer.at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  return (
    <div className="mx-4 mt-3 flex flex-wrap items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900 sm:mx-6" role="status" data-testid="draft-bar" data-draft-bar>
      <History size={16} className="shrink-0 text-amber-600" />
      <span className="min-w-0 flex-1" data-testid="draft-bar-text">You have unsaved changes from <b>{at}</b> on this device.</span>
      <button type="button" onClick={draft.restore} className="rounded-lg bg-amber-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-amber-700" data-testid="draft-restore-btn">Restore</button>
      <button type="button" onClick={draft.discard} className="rounded-lg border border-amber-300 px-3 py-1.5 text-xs font-semibold text-amber-800 hover:bg-amber-100" data-testid="draft-discard-btn">Discard</button>
    </div>
  );
};
